import React from "react";
import { inject, observer } from "mobx-react";
import { useMessageGetter } from "react-message-context";
import {
  emptyError,
  invalidTextAreaError,
  isBlank,
  resolveMaxRows,
  isValidText,
} from "../../../utils/commonUtils";
import TextArea from "./TextArea";

const FeedbackText = observer(
  ({ FeedbackStore, popUpHintLabel = "", placeHolder = "" }) => {
    const key = "text";
    const { feedback, updateError, updateValue, updateIncluded } =
      FeedbackStore;
    const text = feedback.text;
    const msgs = useMessageGetter("feedback.form.text");

    updateIncluded(key, true);

    const handleOnChange = (value) => {
      updateError(key, isValidText(value) ? false : invalidTextAreaError());
      updateValue(key, value);
    };

    const handleOnBlur = () => {
      if (isBlank(text.value)) updateError(key, emptyError(msgs));
    };

    return (
      <div className="cff-feedbackText">
        <TextArea
          id={`CFF-${key}`}
          translations={msgs}
          value={text.value}
          error={text.error}
          rows={3}
          maxRows={resolveMaxRows()}
          maxLength={4000}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          required={true}
          counter={true}
          describedBy="CFF-sensitiveInfo"
          popUpHintLabel={popUpHintLabel}
          placeHolder={placeHolder}
        />
      </div>
    );
  }
);

export default inject("FeedbackStore")(FeedbackText);
